<template>
	<div>
		<v-card v-for="(modul, index) in gard_obj" class="mb-6" :key="index">
			<EditModul :ref="`module-${index}`" :modul="modul" :country="country" :username="username"
				:position="index + 1" @delete="deleteModul(index)" @duplicate="duplicateModul(index)"></EditModul>
		</v-card>
		<div class="flex flex-col lg:flex-row justify-between items-start">
			<a class="btn blue darken-1" @click="addNewModul">Adauga modul nou</a>
			<div class="btn-group">
				<router-link class="btn btn-large blue-grey lighten-2"
					:to="'/oferte-productie/single/' + id">Anuleaza</router-link>
				<button class="btn btn-large" @click="saveModuleGard()">
					Salveaza
				</button>
			</div>
		</div>
		<!-- <pre>Cost: {{ cost_fara_tvaG }}</pre> -->
		<!-- <pre>Pret: {{val_fara_tvaG}}</pre> -->
		<!-- <pre>{{ gard_obj }}</pre> -->
		<!-- <pre>{{$data}}</pre> -->
		<!-- <pre>{{ modeleGard }}</pre> -->
	</div>
</template>

<script>
import EditModul from "@/components/Productie/Garduri/EditModul";

export default {
	name: "EditModule",
	data() {
		return {};
	},
	props: ["gard_obj", "tip", "id", "country", "username"],
	components: {
		EditModul,
	},
	computed: {
		cost_fara_tvaG() {
			if (this.gard_obj.length > 1) {
				let cost = this.gard_obj.reduce(function (a, b) {
					return { cost_total: a.cost_total + b.cost_total };
				});
				return cost.cost_total;
			} else {
				return this.gard_obj[0].cost_total;
			}
		},
		val_fara_tvaG() {
			if (this.gard_obj.length > 1) {
				let pret = this.gard_obj.reduce(function (a, b) {
					return { pret_modul: a.pret_modul + b.pret_modul };
				});
				return pret.pret_modul;
			} else {
				return this.gard_obj[0].pret_modul;
			}
		},

	},
	methods: {
		addNewModul() {
			let nr = this.gard_obj.length + 1;
			this.gard_obj.push({
				nr: "" + nr + "",
				tip: "",
				model: "",
				pp_included: false,
				denumire_model: "",
				latime_profil: "",
				// the model's slat pattern, kept on the module so a saved offer keeps its layout
				slat_widths: [],
				min_gol: "",
				// direction of a custom model, which has no code to read it from
				orientare: "",
				distanta_gol: "",
				ranforsare: "false",
				ranforsari_verticale: 0,
				gol_afisat: "",
				p_gol: "",
				nr_profile: "",
				filename: "",
				pret: "",
				// L and H are the opening to cover; the module is derived from them
				opening_based: true,
				latime: "",
				inaltime: "",
				// derived from the opening by the card, kept so the offer and the PDF can show
				// what was actually built without recomputing it
				modul_latime: "",
				modul_inaltime: "",
				poarta_latime: "",
				poarta_inaltime: "",
				toc_inaltime: "",
				canate: "",
				spatiu_lamele: "",
				// clearance a gate needs to open, subtracted from the opening height
				gol_sus: "",
				gol_jos: "",
				latime_pp: "",
				tip_poarta_mare: "",
				// cross-section of a Stalp module, in mm
				tip_stalp: null,
				buc: 1,
				suprafata: "",
				suprafata_pp: "",
				cost_modul: "",
				cost_total: "",
				marja: "",
				pret_modul: "",
			});
			this.renumber();
		},
		duplicateModul(index) {
			const copy = JSON.parse(JSON.stringify(this.gard_obj[index]));

			this.gard_obj.splice(index + 1, 0, copy);
			this.renumber();
		},
		deleteModul(index) {
			if (this.gard_obj.length > 1) {
				this.gard_obj.splice(index, 1);
				this.renumber();
			}
		},
		// nr rides along in the saved offer, so it has to follow the cards after an add or a delete
		renumber() {
			this.gard_obj.forEach((modul, index) => { modul.nr = "" + (index + 1) });
		},
		/**
		 * Validate every card, not just up to the first bad one - an agent should see all of the
		 * modules that need attention in one pass, not be sent back a card at a time.
		 */
		validateModules() {
			const results = Object.keys(this.$refs)
				.filter(key => key.startsWith("module-"))
				.map(key => {
					const card = this.$refs[key] && this.$refs[key][0];
					return !card || !card.validate ? true : card.validate();
				});

			return results.every(Boolean);
		},
		saveModuleGard() {
			if (!this.validateModules()) {
				M.toast({
					html: "Completeaza campurile obligatorii pentru fiecare modul",
					classes: "bg-red-500"
				});
				return;
			}

			let newGard = {
				gard_obj: JSON.stringify(this.gard_obj),
				cost_fara_tvaG: this.cost_fara_tvaG,
				val_fara_tvaG: this.val_fara_tvaG,
				tip: this.tip,
				id: this.id,
				// the county no longer moves module prices, so saving always clears the flag the
				// backend sets when the county is changed - there is nothing left to recalculate
				change_county: 0
			};
			this.$store.dispatch("saveModuleGard", newGard);
		},
	},
	// the modules price themselves off HUB's fence pricing: the model list and its slat geometry,
	// the base prices for this offer's country, the per-model markups and the shared thresholds
	async created() {
		await Promise.all([
			this.$store.dispatch("hubFencePricing/fetchModels"),
			this.$store.dispatch("hubFencePricing/fetchBasePrices"),
			this.$store.dispatch("hubFencePricing/fetchModelAdjustments"),
			this.$store.dispatch("hubFencePricing/fetchPricingConfig"),
		]);
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#model>input {
	margin-bottom: 8px;
}
</style>
